// OriginBadge — one-glance origin marker for a truth-block leaf.
//
// Distinguishes citation-origin leaves (chat-extracted, researcher-
// confirmed) from submission-origin leaves (user-filed via /submit,
// LLM-triangulated). Also renders the submission bucket
// (fact/fiction/opinion/bounty) as a colored pill.
//
// Pure presentational component. No fetch, no state.
import React from "react";
import { FileText, Send } from "lucide-react";

const BUCKET_CLS = {
  fact: "border-emerald-500/50 text-emerald-300 bg-emerald-500/[0.05]",
  fiction: "border-rose-500/50 text-rose-300 bg-rose-500/[0.05]",
  opinion: "border-amber-500/50 text-amber-300 bg-amber-500/[0.05]",
  bounty: "border-sky-500/50 text-sky-300 bg-sky-500/[0.05]",
};

const STATUS_CLS = {
  fact: "border-emerald-500/50 text-emerald-300",
  web_cited: "border-sky-500/50 text-sky-300",
  fiction: "border-rose-500/50 text-rose-300",
  opinion: "border-amber-500/50 text-amber-300",
  bounty_open: "border-sky-500/50 text-sky-300",
  contested: "border-amber-500/50 text-amber-300",
  theory: "border-zinc-700 text-zinc-400",
  uncited: "border-zinc-800 text-zinc-500",
};

export function OriginBadge({ leaf, testid }) {
  const origin = leaf?.leaf_origin || "citation";
  const isSubmission = origin === "submission";
  const Icon = isSubmission ? Send : FileText;
  const originLabel = isSubmission ? "submission" : "citation";
  const bucket = leaf?.bucket;
  const status = leaf?.epistemic_status;

  return (
    <span className="inline-flex items-center gap-1.5" data-testid={testid}>
      <span
        className={`inline-flex items-center gap-1 px-1.5 py-0.5 border font-mono text-[9px] uppercase tracking-[0.25em] ${
          isSubmission
            ? "border-violet-500/50 text-violet-300 bg-violet-500/[0.05]"
            : "border-cyan-500/50 text-cyan-300 bg-cyan-500/[0.05]"
        }`}
        title={`Leaf origin: ${originLabel}`}
      >
        <Icon className="h-2.5 w-2.5" />
        {originLabel}
      </span>
      {isSubmission && bucket ? (
        <span
          className={`px-1.5 py-0.5 border font-mono text-[9px] uppercase tracking-[0.25em] ${
            BUCKET_CLS[bucket] || "border-zinc-700 text-zinc-400"
          }`}
        >
          {bucket}
        </span>
      ) : (
        <span
          className={`px-1.5 py-0.5 border font-mono text-[9px] uppercase tracking-[0.25em] ${
            STATUS_CLS[status] || "border-zinc-700 text-zinc-400"
          }`}
        >
          {status || "uncited"}
        </span>
      )}
    </span>
  );
}

export default OriginBadge;
